import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import YouTube from 'react-youtube'
import classNames from 'classnames'
import styles from './index.module.scss'
import { PrimaryHeading } from '../../atoms/PrimaryHeading'
import { ICompanyBase } from '../../../types'
import { NoContent } from '../../atoms/NoContent'
import { reactStringReplace, sanitizeUrl, getVideoId } from '../../../utils'
import { URL_PATTERN } from '../../../constants'

type Props = {
  company: ICompanyBase
}

export const CompanyProfileAboutUs: FC<Props> = ({ company }) => {
  const { t } = useTranslation(['companies-[id]'])
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <PrimaryHeading backgroundText='PROFILE' htmlTagType='h2'>
          {t('企業紹介')}
        </PrimaryHeading>
      </div>
      <div>
        {!company?.aboutUs && !company?.conceptPitch && !company?.youtubeUrl && (
          <NoContent>{t('企業紹介がまだ登録されていません。')}</NoContent>
        )}
        {company?.conceptPitch && <p className={styles.conceptPitch}>{company?.conceptPitch}</p>}
        <div
          className={classNames({
            [styles.content]: company?.aboutUs && company?.youtubeUrl,
          })}
        >
          {company?.aboutUs && (
            <div
              className={classNames({
                [styles.aboutUs]: company?.youtubeUrl,
              })}
            >
              <p className={styles.text}>
                {reactStringReplace(company?.aboutUs, URL_PATTERN, (match, i) => (
                  <a key={i} href={sanitizeUrl(match)} target='_blank' rel='noreferrer'>
                    {match}
                  </a>
                ))}
              </p>
            </div>
          )}
          {company?.youtubeUrl && (
            <div
              className={classNames({
                [styles.youtubeContainer]: company?.aboutUs,
                [styles.youtubeWideContainer]: !company?.aboutUs,
              })}
            >
              <YouTube
                videoId={getVideoId(company?.youtubeUrl)}
                className={styles.iframe}
                containerClassName={styles.youtube}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
